
import React from "react";
import oruclicksLogo from "../../../Assets/images/oruclicks-logo.svg";

// Oruclicks logo component (SVG asset)
const CLogo = ({
  size = "45px",
  textSize = "24px",
  showText = true,
  iconOnly = false,
  isDarkTheme = false,
  onClick,
  className,
  style
}) => {
  const resolvedSize = typeof size === "number" ? `${size}px` : size;
  const resolvedTextSize = typeof textSize === "number" ? `${textSize}px` : textSize;

  return (
    <div
      onClick={onClick}
      className={className}
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: "8px",
        cursor: onClick ? "pointer" : "default",
        ...style
      }}
    >
      <img
        src={oruclicksLogo}
        alt="OruClick Logo"
        width={resolvedSize}
        height={resolvedSize}
        style={{
          display: "block",
          filter: isDarkTheme ? "brightness(1.15)" : "none"
        }}
      />
      {!iconOnly && showText && (
        <span
          style={{
            fontSize: resolvedTextSize,
            fontWeight: 600,
            color: isDarkTheme ? "#FFFFFF" : "#111111",
            lineHeight: 1,
            fontFamily: "Manrope, Inter, system-ui, -apple-system, Segoe UI, Roboto, sans-serif",
            letterSpacing: "0.4px",
            textRendering: "optimizeLegibility"
          }}
        >
          <span
            style={{
              fontWeight: 700,
              letterSpacing: "0.6px",
              color: isDarkTheme ? "#FFFFFF" : "#0F172A"
            }}
          >
            Oru
          </span>
          <span
            style={{
              fontWeight: 500,
              color: isDarkTheme ? "#C5D1FF" : "#4B5AB6"
            }}
          >
            Click
          </span>
        </span>
      )}
    </div>
  );
};

export default CLogo;
